export const api = "/api/v1"